import { z } from 'zod';

import { request } from '@/api/httpClient';

const suggestionSchema = z.object({
  udprn: z.number().int().positive(),
  suggestion: z.string().min(1),
});

const addressSchema = z.object({
  udprn: z.number().int().positive(),
  address_line_1: z.string(),
  address_line_2: z.string(),
  address_line_3: z.string(),
  building_name: z.string(),
  building_number: z.string(),
  thoroughfare: z.string(),
  dependent_locality: z.string(),
  post_town: z.string(),
  postcode: z.string(),
  latitude: z.number(),
  longitude: z.number(),
});

export type AddressSuggestion = z.infer<typeof suggestionSchema>;
export type ResolvedAddress = z.infer<typeof addressSchema>;

export async function searchAddresses(query: string): Promise<AddressSuggestion[]> {
  return z.array(suggestionSchema).parse(
    await request<unknown>(`/v2/addresses/search?q=${encodeURIComponent(query)}`),
  );
}

export async function resolveAddress(udprn: number): Promise<ResolvedAddress> {
  return addressSchema.parse(await request<unknown>(`/v2/addresses/${udprn}`));
}
